module.exports = __webpack_public_path__ + "784963f7f2212f9fd5067240549b16d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-30.png
// module id = 2159
// module chunks = 0